export default function IubendaPreferencesLink({ children }) {
   const handleClick = (e) => {
      e.preventDefault();

      if (
         window._iub &&
         window._iub.cs &&
         window._iub.cs.api &&
         typeof window._iub.cs.api.openPreferences === "function"
      ) {
         window._iub.cs.api.openPreferences();
      } else {
         console.warn("Iubenda CS API is not available.");
      }
   };

   return (
      <a
         href="#"
         className="iubenda-cs-preferences-link"
         data-iub-enabled="1"
         onClick={handleClick}
      >
         {children}
      </a>
   );
}
